<template>
  <b-navbar class="satmed-nav shadow" toggleable="lg" type="dark" sticky>
    <b-container>
      <b-navbar-brand href="#">
        <b-img
        style="min-width: 220px;"
        :src="require('@/assets/images/logo.svg')"
        fluid
        alt="Alcaldía de Medellín"></b-img>
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse" is-nav></b-navbar-toggle>
      <b-nav-text class="text-left text-white">
        <b-row>
          <b-col cols="12">
            <h4>Sistema de Alertas Tempranas de Medellín</h4>
          </b-col>
          <b-col cols="12">Para Infancias, Juventudes y Familias</b-col>
        </b-row>
      </b-nav-text>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item @click="$router.push({name: 'Home'})">Inicio</b-nav-item>
          <b-nav-item @click="$router.push({name: 'nuevo-caso'})">Alértanos</b-nav-item>
          <b-nav-item @click="$router.push({name: 'consultar-caso'})">Consultar</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-container>
  </b-navbar>
</template>

<script>
export default {
  name: 'MainNavbar',
};
</script>

<style scoped>
.satmed-nav{
  background-color: #009ee3;
  color: white;
}
.nav-link{
  color: white !important;
  font-size: 1rem;
  font-weight: bold;
  white-space: nowrap;
  transition: 0.5s ease;
}
.nav-link:hover{
  text-shadow: 0px 0px 15px white;
}
</style>
